const Environment = {
    // Default is a SAME-ORIGIN relative path: the browser sends API calls to the
    // exact domain that served the page (e.g. https://stagealm.kinetikalabs.com/api/),
    // and nginx proxies /api/ to the backend. Because it is relative, it works on any
    // domain with no rebuild and can never hit a wrong host/port (the cause of the
    // earlier ERR_CONNECTION_REFUSED).
    //
    // For local dev against a local backend, set REACT_APP_API_URL, e.g.:
    //   REACT_APP_API_URL=http://localhost:5001/api/ npm start
    server_url: process.env.REACT_APP_API_URL || "https://stagealm.kinetikalabs.com/api/",
    crypto_js_key: "Y3J1cHRvanNmb3JxdWVyeQ==",
};
  
export const NewRelicConfig = {
    cloudName: "dtcsaals9", 
    uploadPreset: "Nexus_app_pdfFiles",
};
  
export default Environment;